import { motion } from 'framer-motion';

const DisclaimerSection = () => {
  return (
    <section className="py-16 bg-lavender-50">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white border-2 border-purple-200 rounded-2xl p-8"
        >
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-xl flex-shrink-0">
              <i className="ri-information-line text-2xl text-purple-600"></i>
            </div>
            <div>
              <h3 className="font-serif text-2xl font-bold text-purple-900 mb-4">Important Disclaimer</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>For Entertainment Purposes Only:</strong> OhMyGAWD provides AI-generated responses designed for entertainment, inspiration, and personal reflection. Our oracle is not a substitute for professional advice from qualified experts.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                The guidance provided by OhMyGAWD should <strong>not replace</strong> consultation with licensed professionals including but not limited to: medical doctors, mental health professionals, financial advisors, legal counsel, or other certified experts in their respective fields.
              </p>
              <p className="text-gray-600 text-sm leading-relaxed">
                If you are experiencing a medical emergency, mental health crisis, or require professional assistance, please contact appropriate emergency services or qualified professionals immediately. OhMyGAWD is a tool for exploration and entertainment, not professional consultation.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DisclaimerSection;